__turbopack_context__.v({
  "buttonContainer": "tHjQxa_buttonContainer",
  "horizontal": "tHjQxa_horizontal",
});
